<template>
  <v-container
    fluid
    black
    darken-3
  >
    <v-row class="align-center">
      <v-col cols="12" class="">
        <v-img
          :src="getImgUrl(logo)"
          class='mx-auto'
          contain
          max-width='160'
          height='150'
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    logo: 'logo-instituto.png'
  }),
  methods: {
    getImgUrl(i) {
      return require('../assets/img/'+i)
    },
  }
};
</script>
